// 自定义的表单组件建议放在该目录下。
// 该目录导出的组件会自动注册到Vue中，并且可以被代码生成的模块扫描到
import CargoTypeSelect from '@/components/CargoTypeSelect/index.vue'
import SalespersonSelect from '@/components/SalespersonSelect/index.vue'
import CustomerSelect from '@/components/CustomerSelect/index.vue'
import CustomerProjectSelect from '@/components/CustomerProjectSelect/index.vue'
import CustomerAllSelect from '@/components/CustomerAllSelect/index.vue'
import PortSelect from '@/components/PortSelect/index.vue'
import SupplierSelect from '@/components/SupplierSelect/index.vue'
import OurCompanySelect from '@/components/OurCompanySelect/index.vue'
import WarehouseSelect from '@/components/WarehouseSelect/index.vue'
import ContractSelect from '@/components/ContractSelect/index.vue'
import CargoSpecSelect from '@/components/CargoSpecSelect/index.vue'
import CargoSpecModeSelect from '@/components/CargoSpecModeSelect/index.vue'
import OrderCargoSelect from '@/components/OrderCargoSelect/index.vue'
import LadingCargoDetailSelect from '@/components/LadingCargoDetailSelect/index.vue'
import TransportOrderSelect from '@/components/TransportOrderSelect/index.vue'
import CostItemSelect from '@/components/CostItemSelect/index.vue'
import ContainerLadingOrderSelect  from '@/components/ContainerLadingOrderSelect/index.vue'
import BaseCurrencySelect  from '@/components/BaseCurrencySelect/index.vue'
import LadingCargoDetailMultiSelect from '@/components/LadingCargoDetailMultiSelect/index.vue'
import CompanyBankSelect from '@/components/CompanyBankSelect/index.vue'
import CompanySelectDialog from '@/components/CompanySelectDialog/index.vue'
import ContactSelect from '@/components/ContactSelect/index.vue'
import ProductNameGroupInput from '@/components/ProductNameGroupInput/index.vue'
import TrailerTransportCargoUniNoSelect from '@/components/TrailerTransportCargoUniNoSelect/index.vue'
import BulkShipNameSelect from '@/components/BulkShipNameSelect/index.vue'
import ContactInputOrSelect from '@/components/ContactInputOrSelect/index.vue'
import CrmCustomerCarNoInputOrSelect from '@/components/CrmCustomerCarNoInputOrSelect/index.vue'
import PortTypeSelect from '@/components/PortTypeSelect/index.vue'
import CargoMaterialSelect from '@/components/CargoMaterialSelect/index.vue'
import ShipSelect from '@/components/ShipSelect/index.vue'
import ShipAgencySelect from '@/components/ShipAgencySelect/index.vue'
import CargoClassifySelect from '@/components/CargoClassifySelect/index.vue'
import PayAccountSelect from '@/components/PayAccountSelect/index.vue'
import BlukOrderSelect from '@/components/BlukOrderSelect/index.vue'
export default {
  CargoTypeSelect,
  SalespersonSelect,
  CustomerSelect,
  CustomerProjectSelect,
  CustomerAllSelect,
  SupplierSelect,
  OurCompanySelect,
  PortSelect,
  WarehouseSelect,
  ContractSelect,
  CargoSpecSelect,
  OrderCargoSelect,
  LadingCargoDetailSelect,
  LadingCargoDetailMultiSelect,
  TransportOrderSelect,
  CostItemSelect,
  ContainerLadingOrderSelect,
  BaseCurrencySelect,
  CompanyBankSelect,
  CompanySelectDialog,
  ContactSelect,
  CargoSpecModeSelect,
  ProductNameGroupInput,
  TrailerTransportCargoUniNoSelect,
  BulkShipNameSelect,
  ContactInputOrSelect,
  CrmCustomerCarNoInputOrSelect,
  PortTypeSelect,
  CargoMaterialSelect,
  ShipSelect,
  ShipAgencySelect,
  CargoClassifySelect,
  PayAccountSelect,
  BlukOrderSelect
}
